import { useEffect, useRef } from 'react';
import { isNil } from 'ramda';

/**
 * You can only use this in functional components. This won't work with Recompose.
 */
export const useInterval = (callback, delay, callImmediately = false, condition) => {
  const savedCallback = useRef();

  // Remember the latest callback
  useEffect(() => {
    if (callImmediately && isNil(savedCallback.current)) callback();
    savedCallback.current = callback;
  }, [callback]);

  // Set up interval
  // eslint-disable-next-line consistent-return
  useEffect(() => {
    function tick() {
      savedCallback.current();
    }

    if (delay !== null) {
      const timer = setInterval(() => {
        if (document.visibilityState === 'visible') {
          if (!isNil(condition) && condition) { tick(); return; }
          if (isNil(condition)) tick();
        }
      }, delay);
      return () => clearInterval(timer);
    }
  }, [delay, condition]);
};

/**
 * You can use this version in Recompose or class components
 */
export const useIntervalInClass = (callback, delay, callImmediately = false) => {
  if (callImmediately) callback();

  const timer = setInterval(() => {
    if (document.visibilityState === 'visible') callback();
  }, delay);
  return () => clearInterval(timer);
};



// WEBPACK FOOTER //
// ./src/utils/hooks.js